<div class="col-12 group-chains">
  <div class="col-12 controls">
    <button pButton type="button" [label]="'COMMON.SAVE' | translate"
            [icon]="'fa fa-save'" class="p-button-success" style="float: right;"
            (click)="saveConfig()"></button>
  </div>
  <div class="col-12 lists">
    <p-pickList [source]="availableList" [target]="selectedList"
                [sourceHeader]="'GROUP_MANAGEMENT.COMPONENT.AVAILABLE_CHAINS' | translate"
                [targetHeader]="'GROUP_MANAGEMENT.COMPONENT.SELECTED_CHAINS' | translate"
                [sourceFilterPlaceholder]="'GROUP_MANAGEMENT.COMPONENT.GROUP_CHAINS_PICK_FILTER' |translate"
                [targetFilterPlaceholder]="'GROUP_MANAGEMENT.COMPONENT.GROUP_CHAINS_PICK_FILTER' |translate"
                [responsive]="true" filterBy="sTrtChainName"
                [showSourceControls]="false"
                [showTargetControls]="false"
                [dragdrop]="false">
      <ng-template let-chain pTemplate="item">
        <div class="p-helper-clearfix">
          <div style="font-size:14px;margin:15px 5px 0 0">{{chain.sTrtChainName}}</div>
        </div>
      </ng-template>
    </p-pickList>
  </div>
</div>
